
/*
 * @Author: hzm
 * @Date: 2022-11-21 13:10:22
 * @Description: 
 */
import { Message, MessageBox, Notification, Loading } from "element-ui";

import Base from "../message/base";
class VuetwoMessage extends Base {
  constructor() {
    super(Message, MessageBox, Notification, Loading);
  }
    
}

const modal = new VuetwoMessage();

export { modal }
